import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { formatMoneyShorthand } from 'utils/formatMoney';
import getShareableLink from 'utils/getShareableLink';

const FounderRoomRow = ({ data }) => data?.map((room) => ({
  ...room,
  name: room.name,
  viewCount: room.viewCount,
  isActive: room.isActive ? 'Active' : 'Inactive',
  // eslint-disable-next-line no-nested-ternary
  visibility: room.isPublic ? 'Public' : 'Private',
  isAllFilesIncluded: room.isAllFilesIncluded ? 'Yes' : 'No',
  filesToInclude: room.filesToInclude,
  usesOfCapital: room.usesOfCapital,
  minimumInvestment: formatMoneyShorthand(room.minimumInvestment),
  currentRaiseSize: formatMoneyShorthand(room.currentRaiseSize),
  amountCommitted: formatMoneyShorthand(room.amountCommitted),
  typeOfRaise: room.typeOfRaise,
  investmentStage: room.investmentStage,
  Actions: () => (
    <div className="d-flex align-items-center">
      <ContextMenu
        menuItems={[
          {
            label: 'View Public Link',
            onClick: () => {
              window.open(`/room/${room.id}`, '_blank');
            },
          },
          { label: 'Copy Public Link', onClick: () => getShareableLink(`room/${room.id}`) },
          {
            label: 'Edit',
            onClick: () => {
              handleShowModal('founder-room-edit', {
                ...room,
                dataVaultInclusion: room.isAllFilesIncluded ? 'all' : 'select',
                dealName: room.deal?.name,
              });
            },
          },
          {
            label: 'Delete',
            onClick: () => handleShowModal('founder-room-delete', { ...room }),
          },
        ]}
      />
    </div>
  ),
}));

export default FounderRoomRow;
